import Dialog from './Dialog.js';

class ResetPasswordDialog extends Dialog {
    static create({id, env}) {
        var decorator = env.getDecorator(),
            accountCreationAllowed = env.getInstitution().accountCreationAllowed(),
            unknownUserError = this.resolveUnknownUserError({accountCreationAllowed});

        return new ResetPasswordDialog({id, decorator, unknownUserError});
    }

    static resolveUnknownUserError({accountCreationAllowed}) {
        if (!accountCreationAllowed) {
            return '<span class="error-emphasis">The email address you provided does not have a SimplyAnalytics account.</span>';
        }

        return [
            '<span class="error-emphasis">The email address you provided does not have a SimplyAnalytics account.</span>',
            '<br/><br/>To create a new account now, <a href="#" class="create-account-link">click here</a>.'
        ].join('');
    }

    constructor({id, decorator, unknownUserError}) {
        super({id, autoInitEvents: false});

        this.unknownUserError = unknownUserError;

        this.form = decorator.sectionError(this.getEl());
        this.emailField = decorator.errorAndEnterKeyPress(this.find('.email-input'));
        this.submitButton = decorator.spinnerButton(this.find('.reset-password-button'));

        this.initEvents();
    }

    initEvents() {
        super.initEvents();

        this.emailField.on('enterKeyPress', () => this.maybeTrigger('submitGesture'));
        this.submitButton.click(() => this.maybeTrigger('submitGesture'));
        this.form.on('click', '.create-account-link', event => this.onCreateAccountClick(event));
    }

    addEmailError() {
        this.emailField.addError('The email address you have provided does not appear to be valid.');
    }

    addUnknownUserError() {
        this.form.addError(this.unknownUserError);
    }

    focusEmailField() {
        this.emailField.focus();
    }

    getEmail() {
        return this.emailField.val();
    }

    onCreateAccountClick(event) {
        event.preventDefault();

        this.maybeTrigger('createAccountLink:click');
    }

    setEmail(email) {
        this.emailField.val(email);
    }

    setSubmitting(submitting) {
        this.setEventsEnabled(!submitting);
        this.submitButton.toggleSpinner(submitting);
    }
}

export default ResetPasswordDialog;